(function ($, XTT) {
	'use strict';

	XTT.fbshareevents = {
		_autoload: [
			'bindFBShareEvents'
		],

		bindFBShareEvents: function() {
			$('.fb-share').on('click', XTT.fbshareevents.handleFBShareClick);
		},

		handleFBShareClick: function(e) {
			e.preventDefault();
			var shareUrl = $(this).data('url');
    	window.open("https://www.facebook.com/sharer/sharer.php?u="+shareUrl, "pop", "width=600, height=400, scrollbars=no");
    	return false;
		}

	};

})
(jQuery, XTT);